import { CustomFields } from '@utils/interfaces';

export type MarketingConsentFieldConfig = CustomFields['children'][number];

export enum MarketingConsentFieldType {
  CONSENT = 'consent',
  MESSAGE = 'message',
}

export interface MarketingConsentField {
  config: MarketingConsentFieldConfig;
  id?: string;
  originalIndex: number;
  valueKey: string;
  type: MarketingConsentFieldType;
}

export interface MarketingConsentFormValues {
  contactsDetails: {
    storeCustomFieldsMarketing: Record<string, boolean | undefined>;
  };
}

export interface MarketingConsentFormProps {
  onValidate: (isValid: boolean) => void;
}
